import { PDFDocument } from "pdf-lib";
import Papa from "papaparse";

function jsonArrayToCSV(jsonData) {
  if (!jsonData || jsonData.length === 0) return "";  
  const headers = Object.keys(jsonData[0]);  
  const headerRow = headers.join(',');  
  const dataRows = jsonData.map(obj => {
    return headers.map(header => {
      let value = obj[header];      
      let cellStr = (value === null || value === undefined) ? "" : String(value);

      const isOnlyNumbersStartingWithZero = /^0\d+$/.test(cellStr);

      if (isOnlyNumbersStartingWithZero) {
        return `="${cellStr}"`;
      }      
      if (cellStr.includes(',') || cellStr.includes('"')) {
        return `"${cellStr.replace(/"/g, '""')}"`;
      }

      return cellStr;
    }).join(',');
  });  
  return [headerRow, ...dataRows].join('\n');
}
function correctNumber(data) {
    // data to Array
    let arrData=[];
    Papa.parse(data,{
        header:true,
        skipEmptyLines:true,
        complete: (result)=>{arrData = result.data}
    });
    return jsonArrayToCSV(arrData);
}

export default function downloadCSVFile(data, filename, mime, bom) {
//   console.log('downloadCSVFile :: data :>> ', data);
  const cData = correctNumber(data);  
  var blobData = (typeof bom !== 'undefined') ? [bom, cData] : [cData];
  var blob = new Blob(blobData, {type: mime || 'application/octet-stream'});
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // IE workaround for "HTML7007: One or more blob URLs were
      // revoked by closing the blob for which they were created.
      // These URLs will no longer resolve as the data backing
      // the URL has been freed."
      window.navigator.msSaveBlob(blob, filename);
  }
  else {
      var blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
      var tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      // tempLink.href = blobURL;
       tempLink.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(cData));
      tempLink.setAttribute('download', filename);

      // Safari thinks _blank anchor are pop ups. We only want to set _blank
      // target if the browser does not support the HTML5 download attribute.
      // This allows you to download files in desktop safari if pop up blocking
      // is enabled.
      if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank');
      }

      document.body.appendChild(tempLink);
      tempLink.click();

      // Fixes "webkit blob resource error 1"
      setTimeout(function() {
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
      }, 200)
  }
}


export  function downloadXlsxFile(data, filename, mime, bom) {
    // const cData = correctNumber(data);  
    var blobData = (typeof bom !== 'undefined') ? [bom, data] : [data];     
    var blob = new Blob(blobData, {type: mime || 'application/octet-stream'});
    console.log('mime :>> ', mime);
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were
        // revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    }
    else {
        var blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        // tempLink.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(data));
        tempLink.setAttribute('download', filename);
  
        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
        }
  
        document.body.appendChild(tempLink);
        tempLink.click();
  
        // Fixes "webkit blob resource error 1"
        setTimeout(function() {
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }, 200)
    }
  }




  export function downloadPDF(fileData,filename='reportPdf.pdf') {
    console.log(fileData.data instanceof ArrayBuffer); // Should be true
    console.log(fileData.data.byteLength);

    const arrayBuffer = fileData.data instanceof Uint8Array ? fileData.data.buffer : fileData.data;

    const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were
        // revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    } else {
        var blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);

        // Create a download link
        const downloadLink = document.createElement('a');
        downloadLink.href = blobURL;
        downloadLink.download = filename; // Name of the file. Use the passed fileName parameter
        document.body.appendChild(downloadLink);
        downloadLink.click();
        
        // Remove the link element after the download
        document.body.removeChild(downloadLink);
    }

    setTimeout(function() {
        window.URL.revokeObjectURL(blobURL);
    }, 200);
}

  
  
  
